export var dataHooks = {
  TextInputTag: 'text-input-tag',
  inputTextSuffix: 'input-text-suffix',
  errorIndication: 'input-error-indication'
};